<template>
  <div>
    <main-toolbar>
      <v-toolbar-title>Reports</v-toolbar-title>
      <v-spacer />
      <v-btn
        text
        @click="editRecordId = 'new'"
        :disabled="loading || timePeriodsLoading || reportTemplatesLoading"
      >
        <v-icon small>fa-plus</v-icon>
        <div v-if="!appSmall">&nbsp; Schedule Report</div>
      </v-btn>
      <v-btn
        text
        @click="viewReportEditor = true"
        :disabled="loading || timePeriodsLoading || reportTemplatesLoading"
      >
        <v-icon small>fa-plus</v-icon>
        <div v-if="!appSmall">&nbsp; View Report</div>
      </v-btn>
    </main-toolbar>
    <v-container
      style="position: absolute; top: 0; left: 0; width: 100%; z-index: 10;"
      class="text-center"
      fluid
      align-center
      justify-center
      v-if="loading"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-container>
    <v-simple-table
      v-if="reports.length"
      class="elevation-1"
      fill-height
    >
      <thead>
        <tr>
          <th style="width: 100px"></th>
          <th>Name</th>
          <th>Frequency</th>
          <th>Enabled</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, $index) in items"
          :key="$index"
        >
          <td class="layout pt-1">
            <v-btn
              icon
              small
              color="black"
              :disabled="loading || reportsLoading"
              @click="editRecordId = item.id"
            >
              <v-icon small>fa-edit</v-icon>
            </v-btn>
            <v-btn
              class="ml-0"
              icon
              small
              color="black"
              :disabled="loading || reportsLoading"
              @click="deleteItem(item)"
            >
              <v-icon small>fa-trash-alt</v-icon>
            </v-btn>
          </td>
          <td>{{ item.templateName || '' }}</td>
          <td>{{ item.timePeriodName || '' }}</td>
          <td><v-icon v-if="item.enabled">fa-check</v-icon></td>
        </tr>
      </tbody>
    </v-simple-table>
    <ReportEditor
      v-if="editRecordId"
      :recordId="editRecordId"
      @close="editRecordId = null"
    />
    <ViewReportEditor v-if="viewReportEditor" @close="viewReportEditor = false" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import get from 'lodash/get'
import ReportEditor from './ReportEditor'
import ViewReportEditor from './ViewReportEditor'
import PaginationMixin from '@/mixins/PaginationMixin'

export default {
  mixins: [PaginationMixin],
  components: {
    ReportEditor,
    ViewReportEditor
  },
  data () {
    return {
      loading: true,
      editRecordId: null,
      viewReportEditor: null
    }
  },
  computed: {
    ...mapState('reports', {
      reportsLoading: 'loading',
      reports: 'data',
      reportsMeta: 'meta'
    }),
    ...mapState('reportTemplates', {
      reportTemplatesLoading: 'loading',
      reportTemplates: 'data'
    }),
    ...mapState('timePeriods', {
      timePeriodsLoading: 'loading',
      timePeriods: 'data'
    }),
    items () {
      return this.reports.map(report => ({
        ...report,
        templateName: get(this.reportTemplates.find(t => t.id + '' === report.template + ''), 'name') || '?',
        timePeriodName: get(this.timePeriods.find(t => t.id + '' === report.timeperiod + ''), 'name') || '?'
      }))
    }
  },
  methods: {
    ...mapActions('reports', {
      findReports: 'find',
      deleteReport: 'delete'
    }),
    ...mapActions('reportTemplates', {
      findReportTemplates: 'find'
    }),
    ...mapActions('timePeriods', {
      findTimePeriods: 'find'
    }),
    async deleteItem (item) {
      if (!window.confirm('Are you sure you want to delete this report?')) {
        return
      }
      this.loading = true
      try {
        await this.deleteReport(item.id)
        this.loading = false
      } catch (e) {
        this.loading = false
        throw e
      }
    },
    async loadData () {
      this.loading = true
      try {
        await this.findReports({
          rowCount: 500
        })
        this.loading = false
      } catch (e) {
        this.loading = false
        throw e
      }
    }
  },
  async created () {
    await Promise.all([
      this.loadData(),
      this.findTimePeriods(),
      this.findReportTemplates()
    ])
  }
}
</script>
